import { useEffect, useRef } from 'react';
/**
 * Custom hook to capture click outside by using Rect reference.
 *
 * usage:
 * Example 1. const ref = useOutsideClick(()=> {do something})
 * Example 2. const ref = useOutsideClick(useCallback(()=>{do something}, [deps] ) )
 * Use second example when the callback requires to be updated by changes in the React state.
 *
 * Ref usage: <div ref{ref} />
 * @param {function} callback - callback when click outside is triggered
 * @returns {React.Ref} ref
 */
var useOutsideClick = function (callback) {
    var ref = useRef(null);
    useEffect(function () {
        var handleClick = function (event) {
            // @ts-ignore-next-line
            if (ref.current && !ref.current.contains(event.target)) {
                callback(event);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return function () {
            document.removeEventListener('mousedown', handleClick);
        };
    }, [callback]);
    return ref;
};
export default useOutsideClick;
